import type { ReactNode } from 'react';

type SetupTrustHelperTone = 'info' | 'warning' | 'error';

interface SetupTrustHelperBandProps {
  tone?: SetupTrustHelperTone;
  eyebrow: ReactNode;
  message: ReactNode;
  meta?: ReactNode;
  className?: string;
}

export default function SetupTrustHelperBand({
  tone = 'info',
  eyebrow,
  message,
  meta,
  className = '',
}: SetupTrustHelperBandProps) {
  return (
    <div className={`setup-trust-helper setup-trust-helper--${tone} ${className}`.trim()}>
      <p className="setup-trust-helper__eyebrow">{eyebrow}</p>
      <p className="setup-trust-helper__message">{message}</p>
      {meta ? <div className="setup-trust-helper__meta">{meta}</div> : null}
    </div>
  );
}
